module.exports = __webpack_public_path__ + "static/img/gl-4.1768b6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gallery/gl-4.jpg
// module id = b6QW
// module chunks = 0